import type {
  BoxSearchInterface,
  BoxSearchLegInterface,
} from "../flightAirportInterface";
import { BoxSearchLegClass } from "./bxoxSearchLegClass";

export class BoxSearchClass implements BoxSearchInterface {
  arrival: BoxSearchLegInterface = new BoxSearchLegClass();

  departure: BoxSearchLegInterface = new BoxSearchLegClass();

  constructor(data?: BoxSearchInterface) {
    this.arrival = new BoxSearchLegClass(data?.arrival);
    this.departure = new BoxSearchLegClass(data?.departure);
  }
}
